var _path, _path2, _path3, _path4, _path5, _path6, _use, _path7, _use2, _use3, _path8, _g, _g2, _use4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTj(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-tj",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#060",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v342.9H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M0 0h640v137.1H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8c300",
    d: "M300.8 233.6a8.6 8.6 0 0 1 16 4V272h6.4v-34.3a8.6 8.6 0 0 1 16-4 20.2 20.2 0 1 0-38.4 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M305.4 224.7a13.7 13.7 0 0 1 14.6 6.5 13.7 13.7 0 0 1 14.6-6.5 14.7 14.7 0 0 0-29.2 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "#f8c300",
    d: "M316.8 258.3a26 26 0 0 1-43.8 16.6 27 27 0 0 1-41 12c2.5 25 40 19.9 42.8-4.4 11.7 20.7 37.6 14.7 45.2-10.6z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    width: "100%",
    height: "100%",
    fill: "#f8c300",
    transform: "matrix(-1 0 0 1 640 0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "b",
    fill: "#f8c300",
    d: "M291.8 302.6c-5.3 11.3-15.7 13.2-24.8 4.1 0 0 3.6-2.6 7.6-3.3-.8-3.1.7-7.5 2.9-9.8a15 15 0 0 1 6.1 8.1c5.5-.7 8.2 1 8.2 1z"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    fill: "#f8c300",
    transform: "rotate(9.4 320 551.3)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    width: "100%",
    height: "100%",
    fill: "#f8c300",
    transform: "rotate(18.7 320 551.3)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f8c300",
    strokeWidth: 11,
    d: "M253.5 327.8a233.1 233.1 0 0 1 133 0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f8c300",
    transform: "translate(320 164.6) scale(.68571)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "m301930 415571-790463-574305h977066l-790463 574305L0-513674z",
    transform: "scale(.00005)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "d",
    fill: "#f8c300",
    transform: "translate(320 260.6) scale(.68571)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    transform: "translate(-70 -121.2)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    transform: "translate(-121.2 -70)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    width: "100%",
    height: "100%",
    transform: "translate(-140)"
  }))), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    width: "100%",
    height: "100%",
    fill: "#f8c300",
    transform: "matrix(-1 0 0 1 640 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTj);
export default __webpack_public_path__ + "static/media/tj.4c009c916e4eafb0debdff42d2b7e07e.svg";
export { ForwardRef as ReactComponent };